import { useMemo } from "react"
import { useAuth } from "@/features/auth/context/AuthContext"
import { FREE_TRIAL_CREDITS } from "@/shared/constants/plans"

interface UseCreditResult {
  creditsRemaining: number
  creditsUsed: number
  creditsPurchased: number
  canGenerateImage: boolean
  isLoading: boolean
}

const usePlan = (): UseCreditResult => {
  const { userDetails, loading } = useAuth()

  return useMemo(() => {
    // New users without a creditsRemaining field receive the free trial allocation
    const creditsRemaining: number =
      typeof userDetails?.creditsRemaining === "number" ? userDetails.creditsRemaining : FREE_TRIAL_CREDITS
    const creditsUsed: number = typeof userDetails?.creditsUsed === "number" ? userDetails.creditsUsed : 0
    const creditsPurchased: number =
      typeof userDetails?.creditsPurchased === "number" ? userDetails.creditsPurchased : 0

    return {
      creditsRemaining,
      creditsUsed,
      creditsPurchased,
      canGenerateImage: creditsRemaining > 0,
      isLoading: loading
    }
  }, [userDetails, loading])
}

export { usePlan }
export type { UseCreditResult }
